module.exports = __webpack_public_path__ + "images/5687c866f326d7e96c38a31c6b9edd8d-logo_vita.png";